import Vue from "vue";
import IssuableDetail from "@/components/provider/cards/issuables/IssuableDetail";
import {UserRoleEnum} from "@/enums/userRolesEnum";
import StateControl from "@/componentsReusable/StateControl.vue";
import {IssuableController, StateLicense} from "@/components/provider/cards/issuables/IssuableModels";

export default Vue.component('state-license-detail', {
  name: 'StateLicenseDetail',
  props: {
    stateLicense: {},
    issuableController : Object as () => IssuableController<any>
  },
  components: {
    IssuableDetail,
    StateControl
  },
  computed: {
    isProviderUser(): boolean {
      return this.$store.getters['user/hasOnlyRole'](UserRoleEnum.PROVIDER);
    }
  },

  methods: {
    stateSelected (stateLicense: any, state: any) {
      stateLicense.stateId = state.stateId;
      stateLicense.stateFull = state.stateFull;
    },

    async toggleEditStateLicense(stateLicense: StateLicense) {
      this.$emit('stateLicenseSelected', stateLicense.id);
    },

    reEmitStaleDataEvent() {
      this.$emit('staleData');
    },
    reEmitCancel(issuable : any) {
      this.$emit('cancel', issuable);
    }
  }
});



// WEBPACK FOOTER //
// ./src/components/provider/cards/stateLicenses/StateLicenseDetail.ts